import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;

const createAxiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: token ? `Bearer ${token}` : null,
  },
});

const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);

export const checkUserConflictsApi= async(data)=>{
  const res= await axiosInstance.post( "/lead-assignment/check-user-conflicts", data );
  return res.data;
};
export const bulkAssignLeadApi=async(data)=>{
  const res=await axiosInstance.put( "/lead-assignment/bulk-assign", data );
  return res.data;
};

export const getReassignUserListApi=async()=>{
  const res=await axiosInstance.get( "/adminWork/reassign-user-list" );
  return res.data;
};

export default axiosInstance;